module.exports = __webpack_public_path__ + "static/media/amazonecho-pod.6bbcc932.png";